export default "<div id=\"react--app-project-field-view\"></div>\n"